import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { fetchConeraHistory, downloadFile, FileEntry, DownloadEntry } from "../services/api";

export default function History() {
  const { coneraId } = useParams<{ coneraId: string }>();
  const [files, setFiles] = useState<FileEntry[]>([]);
  const [downloads, setDownloads] = useState<DownloadEntry[]>([]);
  const [loading, setLoading] = useState(true);
  const [downloading, setDownloading] = useState("");

  async function handleDownload(f: FileEntry) {
    setDownloading(f.id);
    try { await downloadFile(f.id, f.filename); }
    catch (err) { alert("Error: " + (err instanceof Error ? err.message : "Error al descargar")); }
    setDownloading("");
  }

  useEffect(() => {
    if (!coneraId) return;
    fetchConeraHistory(coneraId).then((d) => { setFiles(d.files); setDownloads(d.downloads); }).catch(() => {}).finally(() => setLoading(false));
  }, [coneraId]);

  function fmtDate(ts: number) { return new Date(ts).toLocaleDateString("es-MX", { year: "numeric", month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" }); }
  function fmtSize(b: number) { return b < 1024 ? b + " B" : b < 1048576 ? (b / 1024).toFixed(1) + " KB" : (b / 1048576).toFixed(1) + " MB"; }

  return (
    <div>
      <h1 className="text-2xl font-bold text-zinc-100 mb-1">{coneraId}</h1>
      <p className="text-sm text-zinc-500 mb-6">Historial de actividad</p>

      {loading ? (
        <div className="text-zinc-500 py-8 text-center">Cargando...</div>
      ) : (
        <div className="space-y-6">
          <div className="bg-zinc-900 border border-zinc-800 rounded-xl overflow-hidden">
            <div className="px-4 py-3 border-b border-zinc-800">
              <h2 className="font-semibold text-zinc-100 text-sm">Archivos subidos</h2>
            </div>
            {files.length === 0 ? (
              <p className="text-zinc-600 text-sm p-4">No hay archivos subidos para {coneraId}.</p>
            ) : (
              <table className="w-full text-sm">
                <thead>
                  <tr className="border-b border-zinc-800">
                    <th className="text-left px-4 py-2 text-xs font-medium text-zinc-500 uppercase">Version</th>
                    <th className="text-left px-4 py-2 text-xs font-medium text-zinc-500 uppercase">Archivo</th>
                    <th className="text-right px-4 py-2 text-xs font-medium text-zinc-500 uppercase">Tamano</th>
                    <th className="text-right px-4 py-2 text-xs font-medium text-zinc-500 uppercase">Fecha</th>
                    <th className="text-center px-4 py-2 text-xs font-medium text-zinc-500 uppercase">Por</th>
                    <th className="text-center px-4 py-2 text-xs font-medium text-zinc-500 uppercase"></th>
                  </tr>
                </thead>
                <tbody>
                  {files.map((f) => (
                    <tr key={f.id} className="border-b border-zinc-800/50 hover:bg-zinc-800/50">
                      <td className="px-4 py-2 font-semibold text-zinc-100">V{f.version}</td>
                      <td className="px-4 py-2 text-zinc-400">{f.filename}</td>
                      <td className="px-4 py-2 text-right text-zinc-500 text-xs">{fmtSize(f.size)}</td>
                      <td className="px-4 py-2 text-right text-zinc-500 text-xs">{fmtDate(f.uploaded_at)}</td>
                      <td className="px-4 py-2 text-center text-zinc-500 text-xs">{f.uploaded_by}</td>
                      <td className="px-4 py-2 text-center">
                        <button onClick={() => handleDownload(f)} disabled={downloading === f.id}
                          className="text-xs bg-blue-500/10 text-blue-400 hover:bg-blue-500/20 px-3 py-1 rounded-lg transition-colors disabled:opacity-50">
                          {downloading === f.id ? "..." : "Descargar"}
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>

          <div className="bg-zinc-900 border border-zinc-800 rounded-xl overflow-hidden">
            <div className="px-4 py-3 border-b border-zinc-800">
              <h2 className="font-semibold text-zinc-100 text-sm">Historial de descargas</h2>
            </div>
            {downloads.length === 0 ? (
              <p className="text-zinc-600 text-sm p-4">La conera no ha descargado archivos aun.</p>
            ) : (
              <table className="w-full text-sm">
                <thead>
                  <tr className="border-b border-zinc-800">
                    <th className="text-left px-4 py-2 text-xs font-medium text-zinc-500 uppercase">Version</th>
                    <th className="text-right px-4 py-2 text-xs font-medium text-zinc-500 uppercase">Fecha</th>
                  </tr>
                </thead>
                <tbody>
                  {downloads.map((d, i) => (
                    <tr key={i} className="border-b border-zinc-800/50 hover:bg-zinc-800/50">
                      <td className="px-4 py-2 font-semibold text-zinc-100">V{d.version}</td>
                      <td className="px-4 py-2 text-right text-zinc-500 text-xs">{fmtDate(d.checked_at)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
